import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function FirstNonRepeatingChar() {
    const [script, setScript] = useLocalStorage('firstNonRepeatingCharScript', `function firstNonRepeatingChar(input) {
            
}`);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');
    const [showHint, setShowHint] = useState(false);

    const exampleWords = ["swiss", "programming", "level", "javascript", "test", "aabbccd", "aabbcc"];
    const correctResults = exampleWords.map(calculateCorrectResult);

    function calculateCorrectResult(word) {
        const charCount = {};
        for (const char of word) {
            charCount[char] = (charCount[char] || 0) + 1;
        }
        for (const char of word) {
            if (charCount[char] === 1) {
                return char;
            }
        }
        return "";
    }

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');

        try {
            const results = exampleWords.map((word) => {
                const scriptFunction = new Function(`
                    const input = "${word}";
                    ${script}
                    return firstNonRepeatingChar(input);
                `);
                return scriptFunction();
            });

            const formattedOutput = results
                .map((result, index) => `<div>${exampleWords[index]}: ${result}</div>`)
                .join('');
            setSrcDoc(formattedOutput);
            checkPassed(results);
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText('Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:');
            setErrorMessage(e.message);
            setSrcDoc(`<div style="color: red;">Fehler: ${e.message}</div>`);
        }
    }

    function checkPassed(results) {
        for (let i = 0; i < results.length; i++) {
            if (results[i] !== correctResults[i]) {
                setResultTextCss('error-message');
                setResultText(
                    `Deine Lösung ist falsch. Erster Fehler tritt bei "${exampleWords[i]}" auf. Erwartet wurde: "${correctResults[i]}", dein Ergebnis ist allerdings: "${results[i]}".`
                );
                return;
            }
        }
        setResultTextCss('success-result');
        setResultText("Deine Lösung ist korrekt für alle Beispielwörter!");
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>Erster nicht wiederholter Buchstabe</h2>
                <h3>Aufgabenstellung:</h3>
                Deine Aufgabe ist es, die Funktion <code>firstNonRepeatingChar</code> zu implementieren. Sie bekommt über die Variable <code>input</code> ein Wort übergeben und soll den ersten Buchstaben zurückgeben, der **nur einmal** darin vorkommt. Wenn kein solcher Buchstabe existiert, gib einen leeren String zurück.
                <p></p> Beispiel: Bei der Eingabe <code>"swiss"</code> soll <code>"w"</code> zurückgegeben werden.
                <p>Wichtig: Es soll ein einzelner Buchstabe oder ein leerer String zurückgegeben werden.</p>
            </div>

            <div className="aufgaben-container">
                <GroupEditor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="firstNonRepeatingCharScript"
                />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                    <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>
                    <div style={{ display: 'flex', gap: '5px' }}>
                        {exampleWords.map((word, index) => (
                            <div key={index} style={{
                                border: '1px solid #ccc',
                                padding: '5px 10px',
                                borderRadius: '4px',
                                backgroundColor: '#f9f9f9'
                            }}>
                                Testcase {index + 1}: "{word}"
                            </div>
                        ))}
                    </div>
                </div>
                <button className="hint-button" onClick={() => setShowHint(!showHint)}>
                    {showHint ? 'Hinweis ausblenden' : 'Hinweis einblenden'}
                </button>
            </div>

            {showHint && (
                <div style={{
                    marginTop: '10px',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    backgroundColor: '#eef'
                }}>
                    {/*Hier kann der Hinweis geändert werden, falls der Momentan etwas komisch formuliert ist*/}
                    <strong>Hinweis:</strong> Versuch, am besten erst die Menge aller Buchstaben zu zählen und dann den passenden Buchstaben auszugeben
                </div>
            )}

            <div className="ergebnis-text">
                Ergebnis: <br/>
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>

            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="40%"
                />
            </div>
        </>
    );
}

export default FirstNonRepeatingChar;
